// Nail Viet Club — central brand constants (single source of truth)
import logoUrl from "../assets/logo.png";

export const BRAND = {
  name: "Nail Viet Club",
  short: "NV Club",
  domain: "nailvietclub.com",
  poweredBy: "AsterPOS Corp",
  taglineVi: "Kết Nối · Học Hỏi · Phát Triển",
  taglineEn: "Connect · Learn · Grow",
  // Logo imported through Webpack so it ships with a content-hashed filename
  // (e.g. /static/media/logo.5a2b1c3d.png). This auto-invalidates browser cache
  // whenever the file changes — the previous `/logo.png` fixed URL was being
  // cached as a broken-image state from when the external CDN was unreachable.
  logoUrl,
  email: "hello@nailvietclub.com",
  // Toll-free AI Voice line (Agent9). Use the E.164 `phone` for tel: links and the human-friendly display for visible text.
  phone: "+18886956068",
  phoneDisplay: "1-888-695-6068",
};

export const NAV_LINKS = [
  { to: "/events", vi: "Sự Kiện", en: "Events" },
  { to: "/ai", vi: "Cố Vấn AI", en: "AI Advisor" },
  { to: "/resources", vi: "Học Tập", en: "Learning" },
  { to: "/speakers", vi: "Diễn Giả", en: "Speakers" },
  { to: "/board", vi: "Hội Đồng Quản Trị", en: "Board" },
  { to: "/sponsors", vi: "Nhà Tài Trợ", en: "Sponsors" },
  { to: "/about", vi: "Giới Thiệu", en: "About" },
  { to: "/contact", vi: "Liên Hệ", en: "Contact" },
];
